export const propertyEnums = {
  landTypes: {
    'Free Hold': 1,
    'Lease Hold': 2
  },
  
  leaseTypes: {
    'BMC': 1,
    'Collector': 2,
    'BPT': 3,
    'MHADA': 4,
    'Trust Land': 5,
    'Agriculture Land': 6,
    'Society Redevelopment': 7,
    'MIDC': 8
  },

  zones: {
    'Residential Zone': 1,
    'Commercial Zone': 2,
    'Industrial Zone': 3,
    'Agricultural Zone': 4
  },

  proposalFors: {
    'Outright': 1,
    'Joint Venture': 2,
    'Joint Development': 3,
    'Redevelopment': 4,
    'Fresh': 5,
    'DM': 6,
    'SRA': 7
  },

  areaUnits: {
    'Sq.Ft': 1,
    'Sq.Mt': 2,
    'Sq.Yrd': 3,
    'Acres': 4,
    'Guntha': 5
  },
	enquiryTypes: {
    'Outright': 1,
    'Joint Venture': 2,
    'Joint Development': 3,
    'Redevelopment': 4,
    'Fresh': 5,
    'DM': 6,
    'SRA': 7
  }
};

export const getEnumKeys = {
  landTypes: Object.keys(propertyEnums.landTypes),
  leaseTypes: Object.keys(propertyEnums.leaseTypes),
  zones: Object.keys(propertyEnums.zones),
  proposalFors: Object.keys(propertyEnums.proposalFors),
  areaUnits: Object.keys(propertyEnums.areaUnits)
};
